import React, { useEffect, useRef, useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useNotifications } from './NotificationProvider';

/* ─── ikonlar (Telegram modülüyle aynı çizgi stili) ─── */
const P = {
  dashboard: <><rect x="3.5" y="3.5" width="7" height="7" rx="2" /><rect x="13.5" y="3.5" width="7" height="7" rx="2" /><rect x="3.5" y="13.5" width="7" height="7" rx="2" /><rect x="13.5" y="13.5" width="7" height="7" rx="2" /></>,
  bot: <><rect x="4" y="8" width="16" height="11" rx="3" /><path d="M12 4v4M9 13h.01M15 13h.01M2 13v2M22 13v2" /></>,
  chat: <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4h0A2.5 2.5 0 0 1 4 13.5z" />,
  ticket: <><path d="M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4z" /><path d="M14 6v12" strokeDasharray="2 2" /></>,
  clipboard: <><rect x="5" y="4" width="14" height="17" rx="2.5" /><path d="M9 4.5V3h6v1.5M9 10h6M9 14h6M9 18h3" /></>,
  megaphone: <><path d="M4 10v4a1 1 0 0 0 1 1h2l6 4V5L7 9H5a1 1 0 0 0-1 1z" /><path d="M17 8.5a5 5 0 0 1 0 7" /></>,
  target: <><circle cx="12" cy="12" r="8.5" /><circle cx="12" cy="12" r="4.5" /><circle cx="12" cy="12" r="1" fill="currentColor" /></>,
  heart: <path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z" />,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4.5 20.5c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5" /></>,
  chart: <path d="M5 20V12M10 20V6M15 20v-9M20 20V4" />,
  users: <><circle cx="9" cy="8.5" r="3.5" /><path d="M2.5 19.5c.9-3 3.4-4.8 6.5-4.8s5.6 1.8 6.5 4.8" /><path d="M15.5 5.2a3.5 3.5 0 0 1 0 6.6M17.8 14.9c1.8.6 3.1 2.3 3.7 4.6" /></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M3.5 6.5l8.5 6.5 8.5-6.5" /></>,
  money: <><rect x="2.5" y="6" width="19" height="12" rx="2.5" /><circle cx="12" cy="12" r="2.6" /><path d="M6 9.5v5M18 9.5v5" /></>,
  news: <><path d="M5 19a2 2 0 0 1-2-2V6h13v11a2 2 0 0 0 2 2zM16 9h4v8a2 2 0 0 1-2 2" /><path d="M6.5 9.5h6M6.5 13h6M6.5 16.5h4" /></>,
  plane: <path d="M3.4 20.4l17.45-7.48a1 1 0 0 0 0-1.84L3.4 3.6a.99.99 0 0 0-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z" />,
  bell: <><path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z" /><path d="M10 20.5a2 2 0 0 0 4 0" /></>,
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  logout: <><path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" /><path d="M10 16l-4-4 4-4M6 12h10" /></>,
  close: <path d="M6 6l12 12M18 6L6 18" />,
};
function Ic({ n, s = 22, style }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block', flexShrink: 0, ...style }}>
      {P[n]}
    </svg>
  );
}

const sections = [
  { title: 'Genel', items: [
    { to: '/',              icon: 'dashboard', label: 'Dashboard' },
    { to: '/analytics',     icon: 'chart',     label: 'Analitik' },
  ] },
  { title: 'Mesajlaşma', items: [
    { to: '/chat',          icon: 'chat',      label: 'Canlı Sohbet', badge: true },
    { to: '/tickets',       icon: 'ticket',    label: 'Ticketlar' },
    { to: '/applications',  icon: 'clipboard', label: 'Başvurular' },
    { to: '/broadcast',     icon: 'megaphone', label: 'Toplu Mesaj' },
    { to: '/retargeting',   icon: 'target',    label: 'Retargeting' },
    { to: '/notifications', icon: 'bell',      label: 'Bildirimler' },
  ] },
  { title: 'Botlar', items: [
    { to: '/bots',          icon: 'bot',       label: 'Botlar' },
    { to: '/datebot',       icon: 'heart',     label: 'Date Bot' },
    { to: '/profiles',      icon: 'user',      label: 'Profiller' },
    { to: '/users',         icon: 'users',     label: 'Kullanıcılar' },
  ] },
  { title: 'Araçlar', items: [
    { to: '/mail',          icon: 'mail',      label: 'Mail Gönderici' },
    { to: '/affiliate',     icon: 'money',     label: 'Affiliate' },
    { to: '/news-bot',      icon: 'news',      label: 'Haber Botu' },
  ] },
];
// Menüde görünmeyen sayfalar (başlık için)
const HIDDEN_ITEMS = [{ to: '/telegram', label: 'Telegram' }];
const allItems = sections.flatMap(s => s.items);
const titleItems = [...allItems, ...HIDDEN_ITEMS];
const FULL_PAGES = ['/telegram', '/chat'];
const GRADS = [['#ff885e', '#ff516a'], ['#ffcd6a', '#ffa85c'], ['#82b1ff', '#665fff'], ['#a0de7e', '#54cb68'], ['#53edd6', '#28c9b7'], ['#72d5fd', '#2a9ef1'], ['#e0a2f3', '#d669ed']];

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const openRef = useRef(false);
  openRef.current = open;
  const username    = localStorage.getItem('username')    || 'Admin';
  const roleDisplay = localStorage.getItem('roleDisplay') || '';
  const roleColor   = localStorage.getItem('roleColor')   || 'var(--link)';
  const notif = useNotifications() || {};
  const unreadCount = notif.unreadCount || 0;

  const path = location.pathname;
  const current = titleItems.find(i => (i.to === '/' ? path === '/' : path.startsWith(i.to))) || allItems[0];
  const inHidden = HIDDEN_ITEMS.some(i => path.startsWith(i.to));
  const full = FULL_PAGES.some(p => path.startsWith(p));
  const grad = GRADS[[...username].reduce((a, c) => a + c.charCodeAt(0), 0) % GRADS.length];

  useEffect(() => { setOpen(false); }, [path]);
  useEffect(() => {
    document.title = current.label + ' · HR Bot';
  }, [current.label]);
  useEffect(() => {
    if (!open) return undefined;
    const h = e => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', h);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', h); document.body.style.overflow = prev; };
  }, [open]);

  /* Mobil: sol kenardan sağa çekince menü açılır, menü açıkken sola çekince kapanır.
     Sürükleme hiçbir zaman bir menü öğesine tıklama olarak sayılmaz. */
  useEffect(() => {
    let sx = 0, sy = 0, tracking = false, moved = false;
    const isMobile = () => window.innerWidth <= 900;
    function suppressNextClick() {
      const h = ev => { ev.preventDefault(); ev.stopPropagation(); };
      window.addEventListener('click', h, true);
      setTimeout(() => window.removeEventListener('click', h, true), 450);
    }
    function onStart(e) {
      if (!isMobile() || e.touches.length !== 1) return;
      const t = e.touches[0];
      sx = t.clientX; sy = t.clientY; moved = false;
      tracking = openRef.current ? true : sx < 44;
    }
    function onMove(e) {
      if (!tracking) return;
      const t = e.touches[0];
      if (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10) moved = true;
    }
    function onEnd(e) {
      if (!tracking) return;
      tracking = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - sx, dy = t.clientY - sy;
      const horizontal = Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4;
      if (horizontal && !openRef.current && dx > 0) { setOpen(true); suppressNextClick(); }
      else if (horizontal && openRef.current && dx < 0) { setOpen(false); suppressNextClick(); }
      else if (moved && openRef.current) suppressNextClick();
    }
    window.addEventListener('touchstart', onStart, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onEnd, { passive: true });
    return () => {
      window.removeEventListener('touchstart', onStart);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onEnd);
    };
  }, []);

  function logout() { localStorage.clear(); navigate('/login'); }

  return (
    <div className={'app-shell' + (open ? ' drawer-open' : '')}>
      <style>{`
        .app-main.full { --tg-h: 100vh; --tg-radius: 0px; }
        @supports (height: 100dvh) { .app-main.full { --tg-h: 100dvh; } }
        @media (max-width: 900px) {
          .app-main.full { --tg-h: calc(100vh - var(--topbar-h)); }
          @supports (height: 100dvh) { .app-main.full { --tg-h: calc(100dvh - var(--topbar-h)); } }
        }
      `}</style>

      {/* ── Kenar çubuğu ── */}
      <aside className="app-sidebar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 16px 10px', paddingTop: 'max(14px, env(safe-area-inset-top))' }}>
          <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'linear-gradient(180deg,#5eb5f7,#2a8ee0)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', flexShrink: 0 }}>
            <Ic n="bot" s={22} />
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontWeight: 700, fontSize: 16, color: '#fff', lineHeight: 1.2 }}>HR Bot</div>
            <div style={{ fontSize: 12.5, color: 'var(--text3)' }}>Yönetim paneli</div>
          </div>
          <button className="btn-icon btn mobile-only" onClick={() => setOpen(false)} aria-label="Menüyü kapat" style={{ display: 'none' }}>
            <Ic n="close" s={20} />
          </button>
        </div>

        <nav style={{ flex: 1, overflowY: 'auto', padding: '0 8px 8px' }}>
          {sections.map(sec => (
            <div key={sec.title}>
              <div className="nav-section">{sec.title}</div>
              {sec.items.map(item => (
                <NavLink key={item.to} to={item.to} end={item.to === '/'} replace={inHidden} className={({ isActive }) => 'nav-item' + (isActive ? ' active' : '')}>
                  <span className="nav-ic"><Ic n={item.icon} /></span>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.label}</span>
                  {item.badge && unreadCount > 0 && <span className="nav-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div style={{ padding: 8, borderTop: '1px solid var(--border3)', paddingBottom: 'max(8px, env(safe-area-inset-bottom))' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 8px 8px 10px', borderRadius: 10 }}>
            <div style={{ width: 38, height: 38, borderRadius: '50%', flexShrink: 0, background: `linear-gradient(180deg, ${grad[0]}, ${grad[1]})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 600, color: '#fff' }}>
              {(username[0] || '?').toUpperCase()}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#fff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{username}</div>
              <div style={{ fontSize: 12.5, color: roleDisplay ? roleColor : 'var(--text3)' }}>{roleDisplay || 'çevrimiçi'}</div>
            </div>
            <button className="btn btn-icon" onClick={logout} title="Çıkış yap" aria-label="Çıkış yap"><Ic n="logout" s={20} /></button>
          </div>
        </div>
      </aside>

      <div className="app-overlay" onClick={() => setOpen(false)} />

      {/* ── İçerik ── */}
      <main className={'app-main' + (full ? ' full' : '')}>
        <header className="app-topbar">
          <button className="btn btn-icon" onClick={() => setOpen(true)} aria-label="Menü"><Ic n="menu" /></button>
          <div className="title">{current.label}</div>
          <button className="btn btn-icon" onClick={() => navigate('/chat', { replace: inHidden })} aria-label="Canlı sohbet" style={{ position: 'relative' }}>
            <Ic n="chat" />
            {unreadCount > 0 && <span style={{ position: 'absolute', top: 2, right: 0, background: 'var(--accent)', color: '#fff', fontSize: 10.5, fontWeight: 700, borderRadius: 9, minWidth: 18, height: 18, lineHeight: '18px', padding: '0 5px', textAlign: 'center', border: '2px solid var(--surface)' }}>{unreadCount > 99 ? '99+' : unreadCount}</span>}
          </button>
        </header>
        <div className={'app-page' + (full ? ' full' : '')} key={path}>
          <Outlet />
        </div>
      </main>

      <style>{`@media (max-width: 900px) { .app-sidebar .mobile-only { display: inline-flex !important; } }`}</style>
    </div>
  );
}
